<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useLogger } from './composables/useLogger'

const colorMode = useColorMode()
const color = computed(() => colorMode.value === 'dark' ? '#111827' : 'white')
const { t } = useI18n()
const logger = useLogger()

// Global error boundary
onErrorCaptured((error, instance, info) => {
  logger.handleError(error, `Global Error - Captured - ${info}`)

  // Create a Nuxt-compatible error object
  const nuxtError = {
    statusCode: 500,
    statusMessage: error.message || 'Internal Server Error',
    message: error.message,
    stack: error.stack,
  }

  // Show the error page
  showError(nuxtError)

  // Prevent error from propagating further
  return false
})

useHead({
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover' },
    { key: 'theme-color', name: 'theme-color', content: color }
  ],
  link: [
    { rel: 'icon', href: '/favicon.ico' }
  ],
  htmlAttrs: {
    lang: 'en'
  },
  script: [
    {
      src: 'https://accounts.google.com/gsi/client',
      async: true,
      defer: true
    }
  ]
})


const title = t('meta.title')
const description = t('meta.description')

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description,
  ogImage: 'https://dashboard-template.nuxt.dev/social-card.png',
  twitterImage: 'https://dashboard-template.nuxt.dev/social-card.png',
  twitterCard: 'summary_large_image'
})
</script>

<template>
  <div>
    <NuxtLoadingIndicator />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <UNotifications />
    <UModals />
  </div>
</template>
